import { PolicyEntity, PolicyType } from '../types/policy.types';
import { ResponseType } from '../types/shared.types';
import { api } from './api';

export const getPolicyByType = (type: PolicyType) =>
  api.get<ResponseType<PolicyEntity>>(`/v1/policies/${type}`);

export const upsertPolicyByType = (type: PolicyType, content: string) =>
  api.post<ResponseType<PolicyEntity>>(`/v1/policies/${type}`, { content });
